export interface SetDisplaySizeAction {
  type: "SET_DISPLAY_SIZE";
  data: string;
}

export function setDisplaySize(displaySize: string): SetDisplaySizeAction {
  return {
    type: "SET_DISPLAY_SIZE",
    data: displaySize,
  };
}
